<template lang="html">
  <div class="sidebar">
    <router-link to="/"  >
     <img src="/static/logo.svg" class="logo">
    </router-link>


    <div class="menu-wrapper">
      <router-link to="/" class="menu" :class="{'menu-active': (selected==='Accueil')}">
        <div class="menu_element"><i class="fa fa-home"></i></div>
        <h1 class="libelle_menu">Accueil</h1>
      </router-link>
      <router-link to="/devis" class="menu" :class="{'menu-active': (selected==='Devis')}" style="font-size: 32px;">
        <div class="menu_element"><i class="fa fa-calculator"></i></div>
        <h1 class="libelle_menu">Votre devis</h1>
      </router-link>
      <a href="mailto:contact@plantravail.fr" class="menu" style="font-size: 28px">
         <div class="menu_element"><i class="fa fa-envelope"></i></div>
         <h1 class="libelle_menu">Contactez-nous</h1>

      </a>
    </div>
    <div class="foot-logo">
      <img src="/static/dupont.png"><br />
      <img src="/static/quality_network_new.jpg" style="width: 75px;" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selected: 'Accueil'
    }
  },
  mounted () {
    this.selected = this.$route.name
  },
  watch: {
    $route () {
      this.selected = this.$route.name
    }
  }
}
</script>

<style lang="css" scoped>
.libelle_menu {
   font-size: 16px;
   font-weight: bold;
   margin-bottom: 5px;
}
.sidebar {
  background: #FFF;
  position: fixed;
  z-index:100;
  width: 220px;
  max-width: 220px;
  height: 100vh;
  padding: 50px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.logo {
  max-width: 150px;
  width: 100%;
}
.menu-wrapper{
  width: 100%;
}
.menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  color: #969696;
  transition: all .2s ease;
  text-decoration: none;
  font-size: 36px;
}
.menu:hover {
  color: #ff0000;
  transition: all .2s ease;
}
.menu-active {
  color: #ff0000;
  background: #000;
  transition: all .2s ease;
}
.foot-logo img:first-of-type {
  margin-bottom: 20px;

}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?130e80a6